import { clsx } from 'clsx';

export function Select({ children, className, ...rest }) {
  return (
    <select
      className={clsx(
        'bg-surface border border-border-strong rounded pl-3 pr-7 py-2 text-[12.5px] text-text-dark',
        'appearance-none bg-[url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2710%27%20height%3D%2710%27%20viewBox%3D%270%200%2024%2024%27%20fill%3D%27none%27%20stroke%3D%27%23888%27%20stroke-width%3D%273%27%3E%3Cpolyline%20points%3D%276%209%2012%2015%2018%209%27%2F%3E%3C%2Fsvg%3E")] bg-no-repeat bg-[right_10px_center]',
        'focus:outline-none focus:ring-2 focus:ring-gat-green/30 focus:border-gat-green',
        className
      )}
      {...rest}
    >
      {children}
    </select>
  );
}
